import React, {useEffect, useState} from "react";
import FirmSearchIndividualTile from "./FirmSearchIndividualTile";
import {formatSearchLocationText} from "../../data/searchHelper";
import NoSearchResults from "../FormComponents/NoSearchResults";
import axios from "axios";
import {API_KEYS} from "../../__constants__";
import { mapEmptyArr } from '../../utils/utilities'
import IndividualTileSkeleton from "../FormComponents/Skeletons/IndividualTileSkeleton";
import Button from "../Inputs/Button";
import SpinnerIcon from "../vectors/SpinnerIcon";

const FirmSearchPageListings = ({searchType, location, initialFirms, loadingFirmResults}) => {
    const [numberOfVisibleResults, setNumberOfVisibleResults] = useState(5);
    const numberOfResultsForPagination = 5;

    const [loading, setLoading] = useState(false);
    const [tileData, setTileData] = useState([]);
    const [scrollYPos, setScrollYPos] = useState(0);

    const data = {
        totalCount: initialFirms.aggregate_data.total,
        firmType: 'Financial Advice Firms and Mortgage Firms',
    };

    const resultsTitle = () => {
        if (searchType === 'location') {
            if (data.totalCount < numberOfResultsForPagination) {
                return `Showing the top rated and reviewed Financial Advice Firms and Mortgage Firms near ${formatSearchLocationText(location)}`;
            }

            return `Showing the top ${numberOfVisibleResults} rated and reviewed Financial Advice Firms and Mortgage Firms near ${formatSearchLocationText(location)} (out of ${data.totalCount})`;
        }
    };

    const handleShowMoreFirms = async () => {
        if (numberOfVisibleResults < data.totalCount) {
            setLoading(true);
            setScrollYPos(window.scrollY);
            try {
                const nextFirms = await axios.get(`${API_KEYS.API_URL}/v2/public/search/firm-location?query=${location}&offset=${numberOfVisibleResults}`);
                if (nextFirms) {
                    setLoading(false);
                    setNumberOfVisibleResults((data.totalCount - numberOfVisibleResults) > numberOfResultsForPagination ? numberOfVisibleResults + numberOfResultsForPagination : data.totalCount);
                    setTileData(tileData => [...tileData, ...nextFirms.data.data]);
                }
            } catch (error) {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        setTileData(initialFirms.data);
    }, []);

    useEffect(() => {
        window.scrollTo(0, scrollYPos);
    }, [tileData]);

    const getButtonText = () => (
        (data.totalCount - numberOfVisibleResults) < numberOfResultsForPagination ? "Show remaining" : `Show next ${numberOfResultsForPagination}`
    )
    return (
        loadingFirmResults ?
            <div>
                {mapEmptyArr(numberOfResultsForPagination, (i) => <IndividualTileSkeleton key={i}/>)}
            </div>
            :
            data.totalCount ?
                <div className='mt-10 max-sm:mt-2'>
                    <div className='w-full flex flex-wrap box-border'>
                        <div
                            className='my-0 mx-2 pt-0 pl-0 pr-2 pb-2 basis-full flex-grow-0 max-w-full box-border max-sm:mx-0 max-sm:mt-2 max-sm:mb-0'>
                            <h1 className='max-sm:text-base text-xl leading-[1.6] m-0 font-semibold'>
                                {resultsTitle()}
                            </h1>
                        </div>
                        <div
                            className='mt-4 mr-3 mb-0 ml-3 flex-grow-0 max-w-full basis-full box-border max-md:mx-0 max-md:my-4 '
                            key={Math.random()}
                        >
                            {tileData && (
                                <div>
                                    {(tileData).map((item, index) => (
                                        <div key={index} className='mt-4 mr-3 mb-0 ml-3 max-md:mx-0 max-md:my-4 '>
                                            <FirmSearchIndividualTile item={item} index={index}/>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {
                            (data.totalCount > numberOfResultsForPagination && data.totalCount !== numberOfVisibleResults) && (
                                <div className='-mt-6 max-md:mt-4 justify-center  flex flex-grow-0 max-w-full basis-full'>
                                    <Button
                                        onClick={handleShowMoreFirms}
                                        disabled={loading}
                                        className='min-w-[144px] min-h-10'
                                        text={
                                            loading ? (
                                                    <SpinnerIcon size={10}/>)
                                                :
                                                (getButtonText())
                                        }
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>
                :
                <div className='mt-10 max-sm:mt-2'>
                    <div className='w-full flex flex-wrap box-border'>
                        <div className='m-8 flex-grow-0 max-w-full basis-full'>
                            <NoSearchResults searchType="location" showMe="firms"/>
                        </div>
                    </div>
                </div>
    );
};

export default FirmSearchPageListings;